"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VimeoVideo1Schema = void 0;
exports.VimeoVideo1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/vimeo-video/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "VimeoVideo1",
    "description": "Embed a vimeo video",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:vimeo-video:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "id": {
                    "type": "integer",
                    "description": "The id of the vimeo video"
                },
                "hideByline": {
                    "type": "boolean",
                    "default": false
                },
                "hideDescription": {
                    "type": "boolean",
                    "default": false
                },
                "hidePortrait": {
                    "type": "boolean",
                    "default": false
                }
            },
            "required": [
                "id",
                "hideByline",
                "hideDescription",
                "hidePortrait"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy92aW1lby12aWRlby8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGlCQUFpQixHQUFHO0lBQy9CLEtBQUssRUFBRSxnRkFBZ0Y7SUFDdkYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsYUFBYTtJQUN0QixhQUFhLEVBQUUscUJBQXFCO0lBQ3BDLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTix3Q0FBd0M7YUFDekM7U0FDRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixJQUFJLEVBQUU7b0JBQ0osTUFBTSxFQUFFLFNBQVM7b0JBQ2pCLGFBQWEsRUFBRSwyQkFBMkI7aUJBQzNDO2dCQUNELFlBQVksRUFBRTtvQkFDWixNQUFNLEVBQUUsU0FBUztvQkFDakIsU0FBUyxFQUFFLEtBQUs7aUJBQ2pCO2dCQUNELGlCQUFpQixFQUFFO29CQUNqQixNQUFNLEVBQUUsU0FBUztvQkFDakIsU0FBUyxFQUFFLEtBQUs7aUJBQ2pCO2dCQUNELGNBQWMsRUFBRTtvQkFDZCxNQUFNLEVBQUUsU0FBUztvQkFDakIsU0FBUyxFQUFFLEtBQUs7aUJBQ2pCO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsSUFBSTtnQkFDSixZQUFZO2dCQUNaLGlCQUFpQjtnQkFDakIsY0FBYzthQUNmO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=